export const YEN_LABEL = {
    yen: '円（税込）',
    yen_per_year: '円（税込）／年',
  };